import React, { useEffect, useRef, useState } from "react"
import {
    Box, CssBaseline, Grid, CircularProgress, TableBody, TextField, Button,
    Table, TableHead, TableCell, Snackbar, FormControl, Stack, InputLabel, Select,
    MenuItem, TableRow, Pagination, Modal, TableContainer, Paper, IconButton,
    Typography, Autocomplete, Dialog, DialogTitle, DialogContent, DialogActions, Chip
} from "@mui/material"
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import MuiAlert from '@mui/material/Alert'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import { useEvent } from '../../contexts/event.context'
import { format, parseISO } from 'date-fns'
import TableInfo from '../../components/TableInfo'
import TableFrequency from '../../components/TableFrequency'
import api, { baseURL } from '../../services/api'
import { maskCPF2 } from "../../utils/mask";
import * as qs from 'qs';
import ScannerCode from "../../components/ScannerCode";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

export default function Frequencia() {
    const [stateAlert, setStateAlert] = useState({ status: false, type: 'success', msg: '' });
    const [eventReader, setEventReader] = useState();
    const [frequencies, setFrequencies] = useState([]);
    const [subscribers, setSubscribers] = useState([]);
    const [subcriberCode, setSubscriberCode] = useState();
    const selectedEvent = useRef();
    const inputReader = useRef(null);
    const [timer, setTimer] = useState(null);
    const subscriberPrev = useRef(null);
    const [pages, setPages] = useState([]);
    const { events, getEvents, pagination, setPagination } = useEvent();
    const page = useRef(1);
    const query = useRef();
    const [offlineMode, setOfflineMode] = useState(false);
    const [offlineQueue, setOfflineQueue] = useState([]);
    const offlineList = [];
    const [resultImport, setResultImport] = useState([]);
    const [camera, setCamera] = useState(false);
    const [loadingImport, setLoadingImport] = useState(false);
    const [modalimport, setimportmodal] = useState(false);
    const [modalimport2, setimportmodal2] = useState(false);
    const [readAt, setReadAt] = useState();
    const [modalmanual, setModalManual] = useState(false);
    const [manualSubscribers, setManualSubscribers] = useState([]); // Todos os inscritos do evento
    const [selectedSubscribers, setSelectedSubscribers] = useState(new Set()); // IDs dos selecionados
    const [manualReadAt, setManualReadAt] = useState(new Date().toISOString().slice(0, 16)); // Data/hora para registro
    const [loadingManualSubscribers, setLoadingManualSubscribers] = useState(false);
    const [savingManualFrequencies, setSavingManualFrequencies] = useState(false);
    const formImport = new FormData();
    const [loadingEvents, setLoadingEvents] = useState(false);
    const [hasMoreEvents, setHasMoreEvents] = useState(true);
    const [eventOptions, setEventOptions] = useState([]);

    // Novos estados para importação BIP
    const [loadingBip, setLoadingBip] = useState(false);
    const [modalBip, setModalBip] = useState(false);
    const formBip = new FormData();
    const [searchName, setSearchName] = useState('');
    const [searchCPF, setSearchCPF] = useState('');
    const [allFrequencies, setAllFrequencies] = useState([]);
    const [exportingExcel, setExportingExcel] = useState(false);
    const [subscriberModal, setSubscriberModal] = useState({ open: false, name: '', badge: '', reads: [] });

    const [statsData, setStatsData] = useState({
        byDay: {
            labels: [],
            datasets: [{
                label: 'Frequência por Dia',
                data: [],
                backgroundColor: '#8884d8',
                borderColor: '#8884d8',
                borderWidth: 1
            }]
        },
        byShift: {
            labels: [],
            datasets: [{
                data: [],
                backgroundColor: ['#0088FE', '#00C49F', '#FFBB28'],
                borderColor: ['#0088FE', '#00C49F', '#FFBB28'],
                borderWidth: 1
            }]
        },
        byHour: {
            labels: [],
            datasets: [{
                label: 'Frequência por Hora',
                data: [],
                backgroundColor: '#82ca9d',
                borderColor: '#82ca9d',
                borderWidth: 1
            }]
        }
    });

    const onDetected = result => {
        clearTimeout(timer)

        const newTimer = setTimeout(async () => {
            await addFrequencies({ result: result })
        }, 500)

        setTimer(newTimer)
    };


    query.current = qs.stringify({
        filters: {
            event: selectedEvent.current
        },
        sort: ['readAt:desc'],
        populate: {
            event: {
                fields: ['name']
            },
            subscriber: {
                fields: ['id', 'badge', 'email']
            },
            collectors: {
                populate: true
            }
        },
        pagination: {
            pageSize: 10,
            page: page.current,
        },
        encodeValuesOnly: true
    })


    const columns = [
        { Header: "Crachá", accessor: "badge", width: "25%" },
        { Header: "Email", accessor: "email", width: "25%" },
        { Header: "Horário Leitura", accessor: "readAt", width: "30%" }
    ];

    const columnsFrequency = [
        { Header: "#", accessor: "id", width: "25%" },
        { Header: "Nome", accessor: "name", width: "25%" },
        { Header: "Crachá", accessor: "badge", width: "25%" },
        { Header: "Email", accessor: "email", width: "25%" },
        { Header: "Presença", accessor: "actions", width: "25%" }
    ];

    const columnsQueue = [
        { Header: "Evento", accessor: "event", width: "25%" },
        { Header: "ID", accessor: "id", width: "25%" },
        { Header: "Horário Leitura", accessor: "readAt", width: "30%" }
    ];

    async function checkSubscriber(event) {
        setLoadingImport(true)
        console.log(event.target.id, event.target.checked, event.target.attributes)
        if (event.target.checked) {
            try {
                const registerFrequency = await api.post('/frequency/reader', { data: { "event": selectedEvent.current, "id": event.target.id, "readAt": new Date().toISOString() } })
                if (registerFrequency.status === 200) {
                    subscriberPrev.current = event.target.id
                    setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Participante registrado com sucesso!` })
                    handleSubscribers()
                    setSubscriberCode("")
                    setLoadingImport(false)
                    return
                }
                setLoadingImport(false)
            } catch (error) {
                setLoadingImport(false)
                console.log('erro: ' + error)
            }
        } else {
            try {
                let id = subscribers.filter(cods => cods.id == event.target.id)[0].attributes.frequency
                const deleteFrequency = await api.delete(`/frequencies/${id}`)
                if (deleteFrequency.status === 200) {
                    subscriberPrev.current = null
                    setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Participante removido com sucesso!` })
                    handleSubscribers()
                    setSubscriberCode("")
                    setLoadingImport(false)
                    return
                }
                setLoadingImport(false)
            } catch (error) {
                setLoadingImport(false)
                console.log('erro: ' + error)
            }
        }

    }

    async function handleSubscribers() {

        let params = {
            filters: {
                event: selectedEvent.current || eventReader
            },
            sort: ['name:asc'],
            populate: {
                event: {
                    fields: ['name']
                },
            },
            pagination: {
                pageSize: 10,
                page: page.current,
            },
            encodeValuesOnly: true
        }
        query.current = qs.stringify(params, {
            skipNulls: true,
            skipUndefined: true,
            skipEmptyStrings: true
        })
        try {
            const allSubscribers = await api.get(`/subscribers?${query.current}`)
            setPages(allSubscribers.data.meta.pagination)

            let subs = []

            if (allSubscribers.status === 200) {
                subs = [...allSubscribers.data.data]
                await Promise.all(subs.map(async (subscriber, index) => {
                    const { data } = await api.get(`/frequencies?filters[event]=${selectedEvent.current}&filters[subscriber]=${subs[index].id}`);
                    subs[index].attributes.checked = data.data.length > 0 ? true : false
                    subs[index].attributes.id = subs[index].id
                    subs[index].attributes.frequency = data.data.length > 0 ? data.data[0].id : null
                }))
                setSubscribers(subs);
            }

        } catch (erro) {
            console.log(erro)
        }
    }

    async function loadMoreEvents() {
        if (!hasMoreEvents || loadingEvents) return;

        setLoadingEvents(true);
        try {
            await getEvents(pagination.page + 1, pagination.pageSize, true);
            setEventOptions(prev => [...prev, ...events]);
        } catch (error) {
            console.error('Erro ao carregar eventos:', error);
        } finally {
            setLoadingEvents(false);
        }
    }

    // Carrega todos os inscritos do evento para registro manual, com paginação interna
    async function loadAllSubscribersForManual() {
        if (!selectedEvent.current) return;

        setLoadingManualSubscribers(true);
        try {
            // Busca paginada de todos os pedidos do evento
            let page = 1;
            const pageSize = 200;
            let hasMore = true;
            const allOrders = [];

            while (hasMore) {
                const params = {
                    filters: {
                        deleted: { $eq: false },
                        event: { id: { $eq: selectedEvent.current } }
                    },
                    populate: {
                        subscribers: {
                            fields: ['document', 'name', 'email', 'badge']
                        },
                        company: {
                            fields: ['social_reason', 'city', 'state']
                        },
                        plan: {
                            fields: ['type']
                        }
                    },
                    pagination: {
                        pageSize,
                        page
                    }
                };
                const queryString = qs.stringify(params);
                const response = await api.get(`/orders/?${queryString}`);
                allOrders.push(...response.data.data);
                const paginationMeta = response.data.meta?.pagination;
                if (paginationMeta && paginationMeta.page < paginationMeta.pageCount) {
                    page++;
                } else {
                    hasMore = false;
                }
            }

            // Processar inscritos e verificar frequências existentes
            const subscribersMap = new Map();
            const frequencyChecks = [];

            allOrders.forEach(order => {
                const subscribers = order.attributes.subscribers?.data || [];
                subscribers.forEach(subscriber => {
                    if (!subscribersMap.has(subscriber.id)) {
                        const subscriberData = {
                            id: subscriber.id,
                            orderId: order.id,
                            name: subscriber.attributes.name,
                            email: subscriber.attributes?.email || '',
                            document: subscriber.attributes?.document || '',
                            badge: subscriber.attributes?.badge || '',
                            company: order.attributes.company?.data?.attributes?.social_reason || '',
                            city: order.attributes.company?.data?.attributes?.city || '',
                            category: order.attributes.plan?.data?.attributes?.type || '',
                            hasFrequency: false,
                            frequencyId: null
                        };
                        subscribersMap.set(subscriber.id, subscriberData);
                        frequencyChecks.push(
                            api.get(`/frequencies?filters[event]=${selectedEvent.current}&filters[subscriber]=${subscriber.id}`)
                                .then(res => {
                                    if (res.data.data.length > 0) {
                                        subscriberData.hasFrequency = true;
                                        subscriberData.frequencyId = res.data.data[0].id;
                                    }
                                })
                                .catch(err => console.warn('Erro ao verificar frequência:', err))
                        );
                    }
                });
            });

            await Promise.all(frequencyChecks);

            const allSubscribers = Array.from(subscribersMap.values()).sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            setManualSubscribers(allSubscribers);

            // Marcar automaticamente quem já tem frequência
            const alreadyPresent = new Set(
                allSubscribers.filter(s => s.hasFrequency).map(s => s.id)
            );
            setSelectedSubscribers(alreadyPresent);

        } catch (error) {
            console.error('Erro ao carregar inscritos:', error);
            setStateAlert({
                status: true,
                type: 'error',
                msg: 'Erro ao carregar inscritos do evento'
            });
        } finally {
            setLoadingManualSubscribers(false);
        }
    }
    // Botão para marcar todos os inscritos manualmente
    function handleSelectAllManualSubscribers() {
        const allIds = manualSubscribers.map(s => s.id);
        setSelectedSubscribers(new Set(allIds));
    }

    // Botão para desmarcar todos
    function handleDeselectAllManualSubscribers() {
        setSelectedSubscribers(new Set());
    }

    // Salva registros de frequência em lote
    async function saveManualFrequencies() {
        if (selectedSubscribers.size === 0) {
            setStateAlert({
                status: true,
                type: 'warning',
                msg: 'Selecione pelo menos um inscrito para registrar'
            });
            return;
        }

        setSavingManualFrequencies(true);
        try {
            const selectedIds = Array.from(selectedSubscribers);
            const registrations = [];

            for (const subscriberId of selectedIds) {
                const subscriber = manualSubscribers.find(s => s.id === subscriberId);

                // Se já tem frequência, pular
                if (subscriber?.hasFrequency) {
                    continue;
                }

                const data = {
                    event: selectedEvent.current,
                    id: subscriberId,
                    readAt: new Date(manualReadAt).toISOString()
                };

                registrations.push(
                    api.post('/frequency/reader', { data })
                        .catch(err => {
                            console.error(`Erro ao registrar ${subscriber?.name}:`, err);
                            return { error: true, subscriber: subscriber?.name };
                        })
                );
            }

            const results = await Promise.all(registrations);
            const errors = results.filter(r => r?.error);

            if (errors.length > 0) {
                setStateAlert({
                    status: true,
                    type: 'warning',
                    msg: `${results.length - errors.length} registros salvos. ${errors.length} com erro.`
                });
            } else {
                setStateAlert({
                    status: true,
                    type: 'success',
                    msg: `${results.length} frequências registradas com sucesso!`
                });
            }

            // Recarregar lista
            await loadAllSubscribersForManual();
            await handleFrequencies();

        } catch (error) {
            console.error('Erro ao salvar frequências:', error);
            setStateAlert({
                status: true,
                type: 'error',
                msg: 'Erro ao salvar registros de frequência'
            });
        } finally {
            setSavingManualFrequencies(false);
        }
    }

    async function addFrequenciesOffilne(data) {
        try {
            if (offlineQueue.filter(cods => cods.id === data.id).length > 0) {
            }
            await api.post('/frequency/reader', { data: data })
        } catch (err) {
            const { data, error } = err?.response?.data
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
            console.log(err)
        }
    }

    async function addFrequencies({ result }) {
        let dataID = result
        if (!selectedEvent.current) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Selecione um evento para iniciar a leitura` })
            return
        } else if (result <= 0 || result.length <= 0) {
            setSubscriberCode("")
            inputReader.current.focus();
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Código Inválido` })
            return
        } else if (result == subscriberPrev.current) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Inscrito já registrado` })
            setSubscriberCode("")
            inputReader.current.focus();
            return
        } else if (offlineMode) {
            if (offlineList.length > 0 && offlineList.find(cods => cods.id == result) != undefined) {
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Inscrito já registrado` })
                setSubscriberCode("")
                inputReader.current.focus();
                return
            } else if (offlineList.find(cods => cods.id == dataID) == undefined) {
                setOfflineQueue((prevQueue) => [...prevQueue, { event: selectedEvent.current, id: result, readAt: new Date().toISOString() }]);
                offlineList.push({ event: selectedEvent.current, id: result, readAt: new Date().toISOString() })
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Inscrito registrado` })
                setSubscriberCode("")
                subscriberPrev.current = result
                inputReader.current.focus();
                return
            }
        } else if (frequencies.length > 0 && frequencies.find(cods => cods.attributes.subscriber.data.id == result) != undefined) {
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Inscrito já registrado` })
            setSubscriberCode("")
            inputReader.current.focus();
            return
        }
        try {
            const registerFrequency = await api.post('/frequency/reader', { data: { "event": selectedEvent.current, "id": result, "readAt": new Date().toISOString() } })
            if (registerFrequency.status === 200) {
                subscriberPrev.current = result
                setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Participante registrado com sucesso!` })
                handleFrequencies()
                setSubscriberCode("")
                inputReader.current.focus();
                return
            }
        } catch (err) {
            console.log(err, offlineMode)
            const { data, error } = err?.response?.data
            setSubscriberCode("")
            inputReader.current.focus();
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `${error.message}` })
        }
    }

    async function handleFrequencies() {
        let params = {
            filters: {
                event: selectedEvent.current || eventReader,
                $or: [
                    searchName && searchName.trim() !== '' ? {
                        subscriber: {
                            badge: { $containsi: searchName }
                        }
                    } : undefined,
                    searchCPF && searchCPF.trim() !== '' ? {
                        subscriber: {
                            document: { $containsi: searchCPF }
                        }
                    } : undefined
                ].filter(Boolean)
            },
            sort: ['readAt:desc'],
            populate: {
                event: {
                    fields: ['name']
                },
                subscriber: {
                    fields: ['id', 'badge', 'email', 'name', 'document']
                },
                collectors: {
                    populate: true
                }
            },
            pagination: {
                pageSize: 50,
                page: page.current,
            },
            encodeValuesOnly: true
        };

        try {
            // Busca paginada para a tabela (com filtros de nome/CPF aplicados)
            const response = await api.get(`/frequencies?${qs.stringify(params, {
                skipNulls: true,
                skipUndefined: true,
                skipEmptyStrings: true
            })}`);

            setPages(response.data.meta.pagination);

            let subs = response.data.data.map(sub => ({
                ...sub,
                attributes: {
                    ...sub.attributes,
                    badge: sub.attributes.subscriber.data.attributes.badge,
                    email: sub.attributes.subscriber.data.attributes.email,
                    name: sub.attributes.subscriber.data.attributes.name,
                    document: sub.attributes.subscriber.data.attributes.document,
                    readAt2: sub.attributes?.readAt,
                    readAt: format(parseISO(sub.attributes?.readAt), 'dd/MM/yy HH:mm')
                }
            }));

            setFrequencies(subs);

            // Busca TODOS os registros do evento paginando até o fim (para estatísticas sempre completas)
            const PAGE_SIZE_ALL = 100;
            let currentPage = 1;
            let allData = [];
            let totalPages = 1;

            do {
                const paramsAllEvent = {
                    filters: {
                        event: selectedEvent.current || eventReader,
                    },
                    sort: ['readAt:asc'],
                    populate: {
                        subscriber: {
                            fields: ['id', 'name', 'badge']
                        }
                    },
                    pagination: {
                        pageSize: PAGE_SIZE_ALL,
                        page: currentPage,
                    },
                    encodeValuesOnly: true
                };

                const allResponse = await api.get(`/frequencies?${qs.stringify(paramsAllEvent, {
                    skipNulls: true,
                    skipUndefined: true,
                    skipEmptyStrings: true
                })}`);

                allData = allData.concat(allResponse.data.data);
                totalPages = allResponse.data.meta.pagination.pageCount;
                currentPage++;
            } while (currentPage <= totalPages);

            setAllFrequencies(allData);

        } catch (error) {
            console.error('Erro ao buscar frequências:', error);
        }
    }

    // Modifique a função processStats para usar allFrequencies
    async function processStats() {
        if (!allFrequencies || allFrequencies.length === 0) {
            setStatsData(prevState => ({ ...prevState }));
            return;
        }

        try {
            // Agrupa por dia
            const byDay = allFrequencies.reduce((acc, freq) => {
                const date = format(parseISO(freq.attributes.readAt), 'dd/MM/yyyy');
                acc[date] = (acc[date] || 0) + 1;
                return acc;
            }, {});

            // Agrupa por turno
            const byShift = allFrequencies.reduce((acc, freq) => {
                const hour = parseISO(freq.attributes.readAt).getHours();
                let shift = '';
                if (hour >= 6 && hour < 12) shift = 'Manhã';
                else if (hour >= 12 && hour < 18) shift = 'Tarde';
                else shift = 'Noite';

                acc[shift] = (acc[shift] || 0) + 1;
                return acc;
            }, {});

            // Agrupa por hora
            const byHour = allFrequencies.reduce((acc, freq) => {
                const hour = format(parseISO(freq.attributes.readAt), 'HH:00');
                acc[hour] = (acc[hour] || 0) + 1;
                return acc;
            }, {});

            setStatsData({
                byDay: {
                    labels: Object.keys(byDay),
                    datasets: [{
                        label: 'Frequência por Dia',
                        data: Object.values(byDay),
                        backgroundColor: '#8884d8',
                        borderColor: '#8884d8',
                        borderWidth: 1
                    }]
                },
                byShift: {
                    labels: Object.keys(byShift),
                    datasets: [{
                        label: 'Frequência por Turno',
                        data: Object.values(byShift),
                        backgroundColor: ['#0088FE', '#00C49F', '#FFBB28'],
                        borderColor: ['#0088FE', '#00C49F', '#FFBB28'],
                        borderWidth: 1
                    }]
                },
                byHour: {
                    labels: Object.keys(byHour),
                    datasets: [{
                        label: 'Frequência por Hora',
                        data: Object.values(byHour),
                        backgroundColor: '#82ca9d',
                        borderColor: '#82ca9d',
                        borderWidth: 1
                    }]
                }
            });

        } catch (error) {
            console.error('Erro ao processar estatísticas:', error);
        }
    }

    useEffect(() => {
        if (allFrequencies.length > 0) {
            processStats();
        }
    }, [allFrequencies]);

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    useEffect(() => {
        // Verifica a conexão com a API
        const checkConnection = () => {
            const isOnline = navigator.onLine;
            setOfflineMode(!isOnline);
        };
        getEvents();
        window.addEventListener('online', checkConnection);
        window.addEventListener('offline', checkConnection);

        return () => {
            window.removeEventListener('online', checkConnection);
            window.removeEventListener('offline', checkConnection);
        };
    }, []);


    // Função para enviar a fila de dados offline quando a conexão é restabelecida
    const sendOfflineData = async () => {
        offlineQueue.forEach((data) => {
            addFrequenciesOffilne(data)
        });
        setOfflineQueue([]);
        offlineList.length = 0;
    };

    useEffect(() => {
        // Verifica se há uma fila de dados offline para enviar quando a conexão é restabelecida
        if (!offlineMode && offlineQueue.length > 0) {
            sendOfflineData();
            handleFrequencies();
        }
    }, [offlineMode]);

    useEffect(() => {
        if (inputReader.current !== null) {
            inputReader.current.focus();
        }
        handleFrequencies()
    }, []);

    const inputAddSubscriber = e => {
        clearTimeout(timer)

        const newTimer = setTimeout(() => {
            addFrequencies({ result: e.target.value })
        }, 500)

        setTimer(newTimer)
    }

    async function handleImport(event) {
        const files = event.target.files
        formImport.append('file', files[0])
    }

    async function generateCert({ event, document }) {
        try {
            const certificate = await api.post('/certificates', { data: { document, event } })
            if (certificate.status === 200) {
                window.open(`${baseURL + certificate.data[0].url}`, '_blank');
            }
        } catch (error) {
            console.log(error)
            alert(error.response?.data?.error?.message)
        }

    }

    async function sendImport() {
        setLoadingImport(true)
        if (!selectedEvent.current) {
            setLoadingImport(false)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Selecione um evento para iniciar a leitura` })
            return
        } else
            if (!readAt) {
                setLoadingImport(false)
                setStateAlert({ ...stateAlert, status: true, type: 'error', msg: `Selecione uma data e hora para gerar as leituras` })
                return
            }
        formImport.append('event', selectedEvent.current);
        formImport.append('readAt', readAt);
        try {
            const importFrequency = await api.post('/frequency/import', formImport);
            setStateAlert({ ...stateAlert, status: true, type: 'success', msg: `Importação enviada com sucesso` });
            formImport.delete('file')
            setResultImport(importFrequency);
            setLoadingImport(false)
            setimportmodal(false)
            setimportmodal2(true)
        } catch (error) {
            console.log(error)
            setStateAlert({ ...stateAlert, status: true, type: 'error', msg: error.message || error.response.data.error.message })
            formImport.delete('file')
            setLoadingImport(false)
        }
    };

    async function handleBipImport(event) {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const text = await file.text();
            const lines = text.split('\n');
            const readings = lines.map(line => {
                const [code, time, date] = line.split(',').map(item => item.trim());
                if (!code || !time || !date) return null;
                const [hour, minute, second] = time.split(':');
                const [day, month, year] = date.split('/');
                const dateTime = new Date(`20${year}`, month - 1, day, hour, minute, second);

                return {
                    subscriberId: code,
                    readAt: dateTime.toISOString()
                };
            });

            formBip.append('readings', JSON.stringify(readings));
            formBip.append('event', selectedEvent.current);

            setLoadingBip(true);
            const response = await api.post('/frequency/importbip', formBip);
            if (response.status === 200) {
                setStateAlert({
                    status: true,
                    type: 'success',
                    msg: 'Importação BIP realizada com sucesso!'
                });
                if (response.data.summary?.errors > 0) {
                    setStateAlert({
                        status: true,
                        type: 'error',
                        msg: `Importação BIP realizada com ${response.data.summary.errors} erro(s) de ${response.data.summary.total} total!`
                    });
                }

                handleFrequencies();
                setModalBip(false);
            }
        } catch (error) {
            console.error(error);
            setStateAlert({
                status: true,
                type: 'error',
                msg: error.response?.data?.error?.message || 'Erro ao importar arquivo BIP'
            });
        } finally {
            setLoadingBip(false);
            formBip.delete('readings');
            formBip.delete('event');
        }
    };

    // Função para exportar frequências para Excel
    async function handleExportExcel() {
        if (!selectedEvent.current) {
            setStateAlert({
                status: true,
                type: 'warning',
                msg: 'Selecione um evento para exportar'
            });
            return;
        }

        setExportingExcel(true);
        try {
            // Buscar todas as frequências do evento
            const eventName = eventOptions.find(e => e.id === selectedEvent.current)?.attributes?.name;
            if (eventName === undefined) {
                setStateAlert({
                    status: true,
                    type: 'error',
                    msg: 'Nome do evento não encontrado para exportação'
                });
                setExportingExcel(false);
                return;
            }

            const baseParams = {
                filters: {
                    event: { id: { $eq: selectedEvent.current } }
                },
                populate: {
                    event: {
                        fields: ['name'],
                        populate: {
                            collectors: {
                                fields: ['collect_start', 'collect_finish', 'credit']
                            }
                        }
                    },
                    subscriber: {
                        fields: ['id', 'badge', 'email', 'name', 'document','whatsapp'],
                        populate: {
                            company: {
                                fields: ['social_reason', 'city', 'state']
                            }
                        }
                    },
                },
                pagination: {
                    pageSize: 200,
                    page: 1
                },
                encodeValuesOnly: true
            };

            const frequencies = [];
            let currentPage = 1;
            let totalPages = 1;

            do {
                const params = {
                    ...baseParams,
                    pagination: {
                        ...baseParams.pagination,
                        page: currentPage
                    }
                };

                const queryString = qs.stringify(params);
                const response = await api.get(`/frequencies?${queryString}`);
                const pageData = response?.data?.data || [];

                frequencies.push(...pageData);
                totalPages = response?.data?.meta?.pagination?.pageCount || 1;
                currentPage += 1;
            } while (currentPage <= totalPages);

            if (!frequencies || frequencies.length === 0) {
                setStateAlert({
                    status: true,
                    type: 'warning',
                    msg: 'Nenhuma frequência encontrada para exportar'
                });
                return;
            }

            // Buscar todos os collectors do evento
            const eventCollectors = frequencies[0]?.attributes?.event?.data?.attributes?.collectors?.data || [];

            // Agrupar inscritos e suas frequências
            const subscriberMap = new Map();

            frequencies.forEach(freq => {
                const subscriber = freq.attributes.subscriber?.data;
                const subscriberId = subscriber?.id;
                
                if (!subscriberId) return;

                const user = subscriber?.attributes;
                const company = subscriber?.attributes?.company?.data?.attributes;
                const readAt = freq.attributes?.readAt;

                // Se o inscrito já existe no Map, adicionar nova leitura
                if (subscriberMap.has(subscriberId)) {
                    const existing = subscriberMap.get(subscriberId);
                    existing.leituras.push(readAt);
                } else {
                    // Criar novo registro do inscrito
                    subscriberMap.set(subscriberId, {
                        eventName: freq.attributes.event?.data?.attributes?.name || 'N/A',
                        name: user?.name || 'N/A',
                        cpf: user?.document ? maskCPF2(user.document) : 'N/A',
                        email: user?.email || 'N/A',
                        whatsapp: user?.whatsapp || 'N/A',
                        company: company?.social_reason || 'N/A',
                        city: company?.city || '',
                        state: company?.state || '',
                        leituras: [readAt]
                    });
                }
            });

            // Transformar Map em array e calcular carga horária
            const frequencyData = Array.from(subscriberMap.values()).map(subscriber => {
                // Calcular carga horária total baseado nos collectors em que o inscrito esteve presente
                let totalCargaHoraria = 0;
                const collectorsPresentes = new Set();

                // Para cada leitura do inscrito, verificar qual collector corresponde
                subscriber.leituras.forEach(leituraDate => {
                    if (!leituraDate) return;

                    const leitura = parseISO(leituraDate);

                    // Verificar em qual collector esta leitura se encaixa
                    eventCollectors.forEach(collector => {
                        const collectStart = parseISO(collector.attributes?.collect_start);
                        const collectFinish = parseISO(collector.attributes?.collect_finish);
                        const collectorId = collector.id;

                        // Se a leitura está dentro do período do collector
                        if (leitura >= collectStart && leitura <= collectFinish) {
                            // Adicionar collector ao Set (evita contar o mesmo período duas vezes)
                            collectorsPresentes.add(collectorId);
                        }
                    });
                });

                // Somar os créditos dos collectors em que o inscrito esteve presente
                collectorsPresentes.forEach(collectorId => {
                    const collector = eventCollectors.find(c => c.id === collectorId);
                    if (collector) {
                        const credit = parseFloat(collector.attributes?.credit) || 0;
                        totalCargaHoraria += credit;
                    }
                });

                // Criar objeto base
                const row = {
                    'Nome do Evento': subscriber.eventName,
                    'Nome Completo': subscriber.name,
                    'CPF': subscriber.cpf,
                    'Email': subscriber.email,
                    'WhatsApp': subscriber.whatsapp,
                    'Cidade': subscriber.city,
                    'UF': subscriber.state,
                    'Razão Social': subscriber.company,
                    'Presença': subscriber.leituras.length > 0 ? 'Sim' : 'Não',
                    'Carga Horária Total': totalCargaHoraria.toFixed(1) + 'h'
                };

                // Adicionar datas de cada leitura (ordenadas)
                const leiturasOrdenadas = subscriber.leituras
                    .filter(l => l)
                    .sort((a, b) => new Date(a) - new Date(b));

                for (let i = 0; i < Math.max(leiturasOrdenadas.length, eventCollectors.length); i++) {
                    if (leiturasOrdenadas[i]) {
                        row[`Presença ${i + 1}`] = format(parseISO(leiturasOrdenadas[i]), 'dd/MM/yyyy HH:mm:ss');
                    } else {
                        row[`Presença ${i + 1}`] = '';
                    }
                }

                return row;
            });

            // Criar planilha
            const worksheet = XLSX.utils.json_to_sheet(frequencyData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Frequências');

            // Exportar arquivo
            const fileName = `frequencias-${eventName.replace(/[^a-z0-9]/gi, '_').toLowerCase()}-${format(new Date(), 'yyyyMMdd-HHmmss')}.xlsx`;
            XLSX.writeFile(workbook, fileName);

            setStateAlert({
                status: true,
                type: 'success',
                msg: 'Planilha exportada com sucesso!'
            });
        } catch (error) {
            console.error('Erro ao exportar frequências:', error);
            setStateAlert({
                status: true,
                type: 'error',
                msg: 'Erro ao exportar frequências'
            });
        } finally {
            setExportingExcel(false);
        }
    }

    // Cores para o gráfico de pizza
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28'];

    return (
        <Box sx={{ width: '100%', height: '100vh' }}>
            <CssBaseline />
            <Snackbar
                open={stateAlert.status}
                autoHideDuration={2500}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={() => setStateAlert({ status: false, type: 'success', msg: '' })} >
                <Alert sx={{ width: '100%' }} severity={`${stateAlert.type}`}>
                    {stateAlert.msg}
                </Alert>
            </Snackbar>
            <Grid container spacing={4} p={3} justifyContent="center" alignItems="center">
                <Grid item xs={2} md={1} textAlign="right">
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Filtros:
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                        <Autocomplete
                            id="select-event-infinite-scroll"
                            options={eventOptions}
                            loading={loadingEvents}
                            getOptionLabel={(option) => option.attributes?.name || ''}
                            value={eventOptions.find(e => e.id === selectedEvent.current) || null}
                            onChange={async (_, newValue) => {
                                page.current = 1;
                                selectedEvent.current = newValue?.id || '';
                                console.log(selectedEvent.current, newValue);
                                //document.getElementById('asynchronous-companies').value = '';
                                if (newValue.id) await handleFrequencies();
                            }}
                            onOpen={() => {
                                if (eventOptions.length === 0) {
                                    loadMoreEvents();
                                }
                            }}
                            ListboxProps={{
                                onScroll: (event) => {
                                    const listbox = event.currentTarget;
                                    if (
                                        listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 10 &&
                                        hasMoreEvents &&
                                        !loadingEvents
                                    ) {
                                        loadMoreEvents();
                                    }
                                },
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Selecionar Evento"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loadingEvents ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} md={2}>
                    <FormControl fullWidth>
                        <TextField
                            label="Buscar por Nome"
                            variant="outlined"
                            value={searchName}
                            onChange={(e) => {
                                setSearchName(e.target.value);
                                page.current = 1;
                                handleFrequencies();
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} md={2}>
                    <FormControl fullWidth>
                        <TextField
                            label="Buscar por CPF"
                            variant="outlined"
                            value={searchCPF}
                            onChange={(e) => {
                                const formattedCPF = maskCPF2(e.target.value);
                                if (formattedCPF.length <= 14) { // Limita ao tamanho do CPF formatado
                                    setSearchCPF(formattedCPF);
                                    page.current = 1;
                                    handleFrequencies();
                                }
                            }}
                            placeholder="000.000.000-00"
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container p={2} mx={'auto'} spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={2} md={1} textAlign="right">
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Ações:
                    </Typography>
                </Grid>
                <Grid item xs={4} md={2}>
                    <FormControl fullWidth >
                        <TextField
                            margin="dense"
                            fullWidth
                            autoFocus
                            autoComplete="false"
                            ref={inputReader}
                            label="Adicionar Código inscrito"
                            type="number"
                            value={subcriberCode}
                            onChange={(e) => {
                                inputAddSubscriber(e);
                                setSubscriberCode(e.target.value)
                            }}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={4} md={1}>
                    <Button variant='outlined' onClick={() => setCamera(!camera)} sx={{ minHeight: '100%' }} fullWidth>
                        {camera ? "Parar Câmera" : "Usar Câmera"}
                    </Button>
                </Grid>
                <Grid item xs={4} md={1}>
                    <Button variant='outlined' color='success' component="label" fullWidth sx={{ minHeight: '100%' }} disabled={loadingImport} onClick={() => setimportmodal(true)}>
                        Importar
                    </Button>
                </Grid>
                <Grid item xs={4} md={1}>
                    <Button variant='outlined' color='warning' component="label" fullWidth sx={{ minHeight: '100%' }} onClick={() => setModalManual(true)}>
                        Manual
                    </Button>
                </Grid>
                <Grid item xs={4} md={1}>
                    <Button variant='outlined' color='primary' component="label" fullWidth sx={{ minHeight: '100%' }} onClick={() => setModalBip(true)}>
                        BIP
                    </Button>
                </Grid>
                <Grid item xs={4} md={1}>
                    <Button
                        variant='outlined'
                        color='info'
                        fullWidth
                        sx={{ minHeight: '100%' }}
                        onClick={handleExportExcel}
                        disabled={!selectedEvent.current || exportingExcel}
                        startIcon={exportingExcel ? <CircularProgress size={20} /> : <DownloadIcon />}
                    >
                        {exportingExcel ? 'Exportando...' : 'Exportar'}
                    </Button>
                </Grid>
            </Grid>
            {offlineMode && <p>Você está offline. Os dados serão armazenados localmente.</p>}
            {offlineMode && <CircularProgress />}
            <Grid px={5}>
                {camera && <ScannerCode onDetected={onDetected} />}
            </Grid>
            <Grid container p={3}>
                <Box sx={{ width: '100%', overflow: 'hidden', }} >
                    {offlineQueue.length > 0 ?
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columnsQueue.map((column, index) => (
                                        <TableCell
                                            key={index}
                                            align={column.align}
                                            style={{ minWidth: column.width }}
                                        >
                                            {column.Header}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {offlineQueue.map((row, index) => {
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                            {columnsQueue.map((column) => {
                                                const value = column.accessor == 'readAt' ? format(parseISO(row[column.accessor]), 'dd/MM/yy HH:mm') : row[column.accessor]
                                                if (value) return (
                                                    <TableCell key={column.accessor}>
                                                        {value}
                                                    </TableCell>
                                                )
                                            }
                                            )}
                                        </TableRow>
                                    )
                                })
                                }
                            </TableBody>
                        </Table>
                        :
                        null
                    }
                </Box>
            </Grid>

            <Modal
                open={modalimport}
                onClose={() => setimportmodal(false)}
                closeAfterTransition
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    boxShadow: 24,
                    p: 4, width: '40%',
                    height: '60%',
                    backgroundColor: '#eee',
                }}>
                    <Grid container spacing={4} p={3} justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="select-event-infinite-scroll"
                                    options={eventOptions}
                                    loading={loadingEvents}
                                    getOptionLabel={(option) => option.attributes?.name || ''}
                                    value={eventOptions.find(e => e.id === selectedEvent.current) || null}
                                    onChange={async (_, newValue) => {
                                        page.current = 1;
                                        selectedEvent.current = newValue?.id || '';
                                        console.log(selectedEvent.current, newValue);
                                        subscriberPrev.current = null;
                                        //document.getElementById('asynchronous-companies').value = '';
                                        if (newValue.id) await handleFrequencies();
                                    }}
                                    onOpen={() => {
                                        if (eventOptions.length === 0) {
                                            loadMoreEvents();
                                        }
                                    }}
                                    ListboxProps={{
                                        onScroll: (event) => {
                                            const listbox = event.currentTarget;
                                            if (
                                                listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 10 &&
                                                hasMoreEvents &&
                                                !loadingEvents
                                            ) {
                                                loadMoreEvents();
                                            }
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Selecionar Evento"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {loadingEvents ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth >
                                <InputLabel id="select-event">Selecionar Referência:</InputLabel>
                                <Select
                                    labelId="select-refer"
                                    id="select-refer-frequency"
                                    onChange={(event) => {
                                        console.log(event.target.value)
                                        setReadAt(event.target.value)
                                        console.log(readAt)
                                    }
                                    }
                                    label="Selecionar Referência"
                                >
                                    <MenuItem value="">
                                        <em>Nenhum</em>
                                    </MenuItem>
                                    {eventOptions.find(e => e.id === selectedEvent.current && e.attributes.collectors && e.attributes.collectors.data.length > 0) &&
                                        eventOptions.find(e => e.id === selectedEvent.current).attributes.collectors.data.map(collect =>
                                            <MenuItem key={collect.attributes.collect_start} value={collect.attributes.collect_start}>
                                                {`Inicia: ${format(parseISO(collect.attributes.collect_start), "dd/MM/yy HH:mm")} 
                                                Encerra: ${format(parseISO(collect.attributes.collect_finish), "dd/MM/yy HH:mm")} 
                                                    Crédito: ${collect.attributes.credit}h`}
                                            </MenuItem>
                                        )
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Button variant='contained' color='warning' onClick={(e) => e.target.value = null} component="label" fullWidth disabled={loadingImport} >
                                Selecionar Arquivo
                                <input
                                    hidden
                                    name="import"
                                    type={'file'}
                                    onChange={(e) => {
                                        console.log(e.target.value)
                                        handleImport(e)
                                    }}
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    label="import"
                                    sx={{ width: '100%' }}
                                    variant="outlined"
                                />
                            </Button>
                        </Grid>
                        <Grid item xs={12} spacing={2} py={10} md={12} fullWidth sx={{ justifyContent: 'center' }}>
                            <Button variant="contained" fullWidth onClick={() => sendImport()} disabled={loadingImport}>Importar</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
            <Modal
                open={modalimport2}
                onClose={() => setimportmodal2(false)}
                closeAfterTransition
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    boxShadow: 24,
                    p: 1,
                    overflowY: 'auto',
                    width: '70%',
                    height: '90%',
                    backgroundColor: '#eee',
                }}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Nome</TableCell>
                                    <TableCell>CPF</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Celular</TableCell>
                                    <TableCell>Ação</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {resultImport.data !== undefined && resultImport.data.length > 0 && resultImport.data.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell width='16%'>
                                            {row.status == 'rejected' ? <>
                                                <ErrorIcon color="error" />
                                                <Typography fontSize={12} flexWrap>{row.reason?.msg}</Typography>
                                            </> : <CheckCircleIcon color="success" />}
                                        </TableCell>
                                        {console.log(row.reason?.subscriber || row.value?.subscriber)}
                                        {row.reason?.subscriber || row.value?.subscriber ?
                                            <>
                                                <TableCell>{row.reason?.subscriber?.name || row.value?.subscriber?.name}</TableCell>
                                                <TableCell>{row.reason?.subscriber?.document || row.value?.subscriber?.document}</TableCell>
                                                <TableCell>{row.reason?.subscriber?.email || row.value?.subscriber?.email}</TableCell>
                                                <TableCell>{row.reason?.subscriber?.whatsapp || row.value?.subscriber?.whatsapp}</TableCell>
                                            </>
                                            : <>
                                                <TableCell>{row.reason?.id || row.value?.id}</TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </>}
                                        <TableCell>
                                            {row.status == 'rejected' && (
                                                <IconButton color="error" onClick={() => alert(row.reason?.msg)}>
                                                    <VisibilityIcon />
                                                </IconButton>
                                            )}
                                            {row.status == 'fulfilled' && (
                                                <IconButton color="primary" onClick={() => generateCert({ event: row.value?.event.name || row.reason?.event.name, document: row.value?.subscriber?.document || row.reason?.subscriber?.document })}>
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            )}
                                            {row.reason?.event == 'fulfilled' && (

                                                <IconButton color="primary" onClick={() => generateCert({ event: row.value?.event.name || row.reason?.event.name, document: row.value?.subscriber?.document || row.reason?.subscriber?.document })}>
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', m: 5 }}>
                        <Button variant='contained' onClick={() => setimportmodal2(false)}>Ok</Button>
                    </Box>
                </Box>
            </Modal>
            <Modal
                open={modalmanual}
                onClose={() => {
                    setEventReader("")
                    selectedEvent.current = null
                    setManualSubscribers([])
                    setSelectedSubscribers(new Set())
                    setManualReadAt(new Date().toISOString().slice(0, 16))
                    setModalManual(false)
                    handleFrequencies()
                }}
                closeAfterTransition
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    boxShadow: 24,
                    overflowY: 'auto',
                    p: 4,
                    width: '95%',
                    maxHeight: '90%',
                    backgroundColor: '#fff',
                    borderRadius: 2
                }}>
                    <Typography variant="h5" mb={3} textAlign="center">
                        Registro Manual de Frequência
                    </Typography>

                    <Grid container spacing={3}>
                        {/* Seletor de Evento */}
                        <Grid item xs={12} md={8}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="select-event-manual"
                                    options={eventOptions}
                                    loading={loadingEvents}
                                    getOptionLabel={(option) => option.attributes?.name || ''}
                                    value={eventOptions.find(e => e.id === selectedEvent.current) || null}
                                    onChange={async (_, newValue) => {
                                        selectedEvent.current = newValue?.id || '';
                                        setEventReader(newValue?.id || '');
                                        setManualSubscribers([]);
                                        setSelectedSubscribers(new Set());
                                        if (newValue?.id) {
                                            await loadAllSubscribersForManual();
                                        }
                                    }}
                                    onOpen={() => {
                                        if (eventOptions.length === 0) {
                                            loadMoreEvents();
                                        }
                                    }}
                                    ListboxProps={{
                                        onScroll: (event) => {
                                            const listbox = event.currentTarget;
                                            if (
                                                listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 10 &&
                                                hasMoreEvents &&
                                                !loadingEvents
                                            ) {
                                                loadMoreEvents();
                                            }
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Selecionar Evento"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {loadingEvents ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        {/* Campo de Data/Hora */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                type="datetime-local"
                                label="Data/Hora da Presença"
                                value={manualReadAt}
                                onChange={(e) => setManualReadAt(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled={!selectedEvent.current}
                            />
                        </Grid>

                        {/* Tabela de Inscritos */}
                        {loadingManualSubscribers ? (
                            <Grid item xs={12} textAlign="center" py={5}>
                                <CircularProgress />
                                <Typography variant="body1" mt={2}>
                                    Carregando inscritos...
                                </Typography>
                            </Grid>
                        ) : manualSubscribers.length > 0 ? (
                            <>
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                        <Typography variant="h6">
                                            Total: {manualSubscribers.length} inscritos | Selecionados: {selectedSubscribers.size}
                                        </Typography>
                                        <Box>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => {
                                                    const allIds = new Set(manualSubscribers.map(s => s.id));
                                                    setSelectedSubscribers(allIds);
                                                }}
                                                sx={{ mr: 1 }}
                                            >
                                                Marcar Todos
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => setSelectedSubscribers(new Set())}
                                            >
                                                Desmarcar Todos
                                            </Button>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12}>
                                    <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell padding="checkbox">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedSubscribers.size === manualSubscribers.length}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setSelectedSubscribers(new Set(manualSubscribers.map(s => s.id)));
                                                                } else {
                                                                    setSelectedSubscribers(new Set());
                                                                }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>Nome</TableCell>
                                                    <TableCell>Email</TableCell>
                                                    <TableCell>Documento</TableCell>
                                                    <TableCell>Empresa</TableCell>
                                                    <TableCell>Categoria</TableCell>
                                                    <TableCell>Status</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {manualSubscribers.map((subscriber) => (
                                                    <TableRow
                                                        key={subscriber.id}
                                                        sx={{
                                                            backgroundColor: subscriber.hasFrequency ? '#e8f5e9' : 'inherit',
                                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                                        }}
                                                    >
                                                        <TableCell padding="checkbox">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedSubscribers.has(subscriber.id)}
                                                                onChange={(e) => {
                                                                    const newSet = new Set(selectedSubscribers);
                                                                    if (e.target.checked) {
                                                                        newSet.add(subscriber.id);
                                                                    } else {
                                                                        newSet.delete(subscriber.id);
                                                                    }
                                                                    setSelectedSubscribers(newSet);
                                                                }}
                                                                disabled={subscriber.hasFrequency}
                                                            />
                                                        </TableCell>
                                                        <TableCell>{subscriber.name}</TableCell>
                                                        <TableCell>{subscriber.email}</TableCell>
                                                        <TableCell>{subscriber.document}</TableCell>
                                                        <TableCell>{subscriber.company}</TableCell>
                                                        <TableCell>{subscriber.category}</TableCell>
                                                        <TableCell>
                                                            {subscriber.hasFrequency ? (
                                                                <Typography variant="caption" color="success.main">
                                                                    ✓ Já registrado
                                                                </Typography>
                                                            ) : (
                                                                <Typography variant="caption" color="text.secondary">
                                                                    Pendente
                                                                </Typography>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </>
                        ) : selectedEvent.current ? (
                            <Grid item xs={12} textAlign="center" py={5}>
                                <Typography variant="body1" color="text.secondary">
                                    Nenhum inscrito encontrado para este evento
                                </Typography>
                            </Grid>
                        ) : (
                            <Grid item xs={12} textAlign="center" py={5}>
                                <Typography variant="body1" color="text.secondary">
                                    Selecione um evento para carregar os inscritos
                                </Typography>
                            </Grid>
                        )}

                        {/* Botões de Ação */}
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setEventReader("")
                                        selectedEvent.current = null
                                        setManualSubscribers([])
                                        setSelectedSubscribers(new Set())
                                        setModalManual(false)
                                    }}
                                    disabled={savingManualFrequencies}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={saveManualFrequencies}
                                    disabled={!selectedEvent.current || selectedSubscribers.size === 0 || savingManualFrequencies}
                                    startIcon={savingManualFrequencies ? <CircularProgress size={20} /> : null}
                                >
                                    {savingManualFrequencies ? 'Salvando...' : `Salvar (${selectedSubscribers.size})`}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <Grid container p={2} justifyContent="center" alignItems="center">
                <TableInfo
                    title='Registro de Frequencia'
                    variant="info"
                    rows={frequencies}
                    columns={columns}
                    onRowClick={(row) => {
                        const subscriberId = row.attributes.subscriber?.data?.id;
                        if (!subscriberId) return;
                        const reads = allFrequencies
                            .filter(f => f.attributes.subscriber?.data?.id === subscriberId)
                            .sort((a, b) => new Date(a.attributes.readAt) - new Date(b.attributes.readAt))
                            .map(f => format(parseISO(f.attributes.readAt), 'dd/MM/yyyy HH:mm:ss'));
                        setSubscriberModal({
                            open: true,
                            name: row.attributes.name || row.attributes.badge || 'N/A',
                            badge: row.attributes.badge,
                            reads
                        });
                    }}
                />
            </Grid>

            <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2} mx={10}>
                <Pagination count={pages.pageCount} defaultPage={1} color="primary" page={page.current}
                    onChange={(event, value) => {
                        page.current = value
                        handleFrequencies()
                    }} />
            </Stack>

            {/* Modal para importação BIP */}
            <Modal
                open={modalBip}
                onClose={() => setModalBip(false)}
                closeAfterTransition
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    boxShadow: 24,
                    p: 4, width: '40%',
                    height: '60%',
                    backgroundColor: '#eee',
                }}>
                    <Grid container spacing={4} p={3} justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="select-event-infinite-scroll"
                                    options={eventOptions}
                                    loading={loadingEvents}
                                    getOptionLabel={(option) => option.attributes?.name || ''}
                                    value={eventOptions.find(e => e.id === selectedEvent.current) || null}
                                    onChange={async (_, newValue) => {
                                        page.current = 1;
                                        selectedEvent.current = newValue?.id || '';
                                        setEventReader(newValue?.id || '');
                                        if (newValue.id) await handleFrequencies();
                                    }}
                                    onOpen={() => {
                                        if (eventOptions.length === 0) {
                                            loadMoreEvents();
                                        }
                                    }}
                                    ListboxProps={{
                                        onScroll: (event) => {
                                            const listbox = event.currentTarget;
                                            if (
                                                listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 10 &&
                                                hasMoreEvents &&
                                                !loadingEvents
                                            ) {
                                                loadMoreEvents();
                                            }
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Selecionar Evento"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {loadingEvents ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <Button variant='contained' color='warning' onClick={(e) => e.target.value = null} component="label" fullWidth disabled={loadingBip} >
                                Selecionar Arquivo BIP
                                <input
                                    hidden
                                    name="import-bip"
                                    type={'file'}
                                    onChange={(e) => {
                                        handleBipImport(e)
                                    }}
                                    accept=".txt"
                                    label="import-bip"
                                    sx={{ width: '100%' }}
                                    variant="outlined"
                                />
                            </Button>
                        </Grid>
                        <Grid item xs={12} spacing={2} py={10} md={12} fullWidth sx={{ justifyContent: 'center' }}>
                            <Button variant="contained" fullWidth onClick={() => setModalBip(false)} disabled={loadingBip}>Fechar</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <Grid container spacing={2} p={2}>
                <Grid item xs={12} md={4}>
                    <Typography variant="h6" align="center">Frequência por Dia</Typography>
                    <Box sx={{ height: 300, position: 'relative' }}>
                        <Bar
                            data={statsData.byDay}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                    y: {
                                        beginAtZero: true,
                                        ticks: { precision: 0 }
                                    },
                                    x: {
                                        ticks: { maxRotation: 45, minRotation: 45 }
                                    }
                                }
                            }}
                        />
                    </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Typography variant="h6" align="center">Frequência por Turno</Typography>
                    <Box sx={{ height: 300, position: 'relative' }}>
                        <Pie
                            data={statsData.byShift}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: {
                                        position: 'bottom'
                                    }
                                }
                            }}
                        />
                    </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Typography variant="h6" align="center">Frequência por Hora</Typography>
                    <Box sx={{ height: 300, position: 'relative' }}>
                        <Bar
                            data={statsData.byHour}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                scales: {
                                    y: {
                                        beginAtZero: true,
                                        ticks: { precision: 0 }
                                    }
                                }
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>

            {/* Modal de linha do tempo do inscrito */}
            <Dialog
            open={subscriberModal.open}
            onClose={() => setSubscriberModal({ open: false, name: '', badge: '', reads: [] })}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Box>
                    <Typography variant="h6">{subscriberModal.name}</Typography>
                    {subscriberModal.badge && (
                        <Typography variant="body2" color="text.secondary">Crachá {subscriberModal.badge}</Typography>
                    )}
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Total de leituras registradas:
                    </Typography>
                    <Chip label={subscriberModal.reads.length} color="primary" size="small" />
                </Box>
                {subscriberModal.reads.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" textAlign="center" py={3}>
                        Nenhuma leitura encontrada
                    </Typography>
                ) : (
                    <Box sx={{ position: 'relative', pl: 2 }}>
                        {/* Linha vertical da timeline */}
                        <Box sx={{
                            position: 'absolute',
                            left: 11,
                            top: 0,
                            bottom: 0,
                            width: 2,
                            backgroundColor: '#e0e0e0'
                        }} />
                        {subscriberModal.reads.map((readAt, idx) => (
                            <Box
                                key={idx}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: 2,
                                    mb: 1.5,
                                    position: 'relative'
                                }}
                            >
                                {/* Bolinha da timeline */}
                                <Box sx={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: '50%',
                                    backgroundColor: idx === 0 ? '#43a047' : idx === subscriberModal.reads.length - 1 ? '#e53935' : '#1976d2',
                                    border: '2px solid white',
                                    boxShadow: '0 0 0 2px #1976d2',
                                    flexShrink: 0,
                                    mt: 0.4,
                                    zIndex: 1
                                }} />
                                <Box sx={{
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: 1,
                                    px: 1.5,
                                    py: 0.75,
                                    flex: 1
                                }}>
                                    <Typography variant="body2" fontWeight={500}>
                                        {idx === 0 ? '1ª entrada' : idx === subscriberModal.reads.length - 1 ? `Última leitura` : `Leitura ${idx + 1}`}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {readAt}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setSubscriberModal({ open: false, name: '', badge: '', reads: [] })}>
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
        </Box>
    )

}